// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"2907b85a","354":"70109b68","838":"7eac800f"}[chunkId] + ".js";
};